import licenseModule from '../../license.module';
import template from './licenseUsageDetailUser.component.html';
import style from './licenseUsageDetailUser.component.css';

export default licenseModule.component('licenseUsageDetailUser', {
    template,
    style,
    controller: [
        'alertLevelConstants',
        'doughnutColorConstants',
        licenseUsageDetailUserComponent
    ],
    bindToController: true,
    bindings: {
        userUsage: '<'
    }
});

function licenseUsageDetailUserComponent(
    alertLevelConstants,
    doughnutColorConstants
) {
    var vm = this;
    vm.$onChanges = render;
    vm.options = {
        showIcon: true
    };

    vm.size = 50;
    vm.value = 10;
    vm.total = 0;
    vm.used = 0;
    vm.remaining = 0;

    function render(changeObj) {
        if (
            changeObj.userUsage.currentValue &&
            changeObj.userUsage.currentValue != null
        ) {
            initializeValues();
            vm.total =
                vm.userUsage.subscription.total > 0
                    ? vm.userUsage.subscription.total
                    : vm.userUsage.perpetual.total;
            vm.used =
                vm.userUsage.subscription.usage > 0
                    ? vm.userUsage.subscription.usage
                    : vm.userUsage.perpetual.usage;

            vm.actualUsed = vm.userUsage.usage;

            vm.remaining = vm.total - vm.used < 0 ? 0 : vm.total - vm.used;

            vm.showStaticUsage = vm.userUsage.showStaticAllocation;

            vm.percentage = parseFloat((vm.used / vm.total) * 100);

            setProgressBar();
        }
    }

    function initializeValues() {
        if (vm.userUsage.subscription.total == undefined) {
            vm.userUsage.subscription.total = 0;
        }
        if (vm.userUsage.perpetual.total == undefined) {
            vm.userUsage.perpetual.total = 0;
        }
        if (vm.userUsage.subscription.usage == undefined) {
            vm.userUsage.subscription.usage = 0;
        }
        if (vm.userUsage.perpetual.usage == undefined) {
            vm.userUsage.perpetual.usage = 0;
        }
        if (vm.userUsage.usage == undefined) {
            vm.userUsage.usage = 0;
        }
    }

    function setProgressBar() {
        if (!vm.userUsage.legacy) {
            if (vm.percentage >= 100) {
                vm.progressType = alertLevelConstants.critical.toLowerCase();
                vm.percentageColor = doughnutColorConstants.red;
            } else if (vm.percentage >= 75) {
                vm.progressType = alertLevelConstants.warning.toLowerCase();
                vm.percentageColor = doughnutColorConstants.yellow;
            } else {
                vm.progressType = alertLevelConstants.none.toLowerCase();
                vm.percentageColor = doughnutColorConstants.blue;
            }
        } else {
            vm.progressType = 'grey';
            vm.percentageColor = doughnutColorConstants.grey;
        }

        vm.percentage =
            vm.percentage > 100 ? '>100' : parseInt(vm.percentage, 10);
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-usage-detail-user/licenseUsageDetailUser.component.js